import 'whatwg-fetch';
import 'devextreme/data/odata/store';
import DataGrid, { Column, Paging, Pager, FilterRow, Export, Scrolling } from 'devextreme-react/data-grid';
import reportService from '@/projects/platform/services/report-service';
import DataSource from 'devextreme/data/data_source';
import SelectBox from 'devextreme-react/select-box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import lookupService from '@/projects/platform/services/lookup-service';
import { DateBox } from 'devextreme-react';
import { FilterDescriptor } from 'devextreme/data';
import { useState } from 'react';
import { reatiler } from '@/core/utils/report-datas';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
import { start } from 'repl';
import { Toast } from 'devextreme-react/toast';
import { formatDate } from 'devextreme/localization';
import { extFormatDate } from '@/core/helper/date-helper';

var store = new DataSource({});
function isNotEmpty(value: any) {
    return value !== undefined && value !== null && value !== '';
}
function getDataSource(filter: any) {

    store = new DataSource({
        filter: filter,
        load(loadOptions: any) {
            let params = '?';
            [
                'skip',
                'take',
            ].forEach((i) => {
                if (i in loadOptions && isNotEmpty(loadOptions[i])) { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
            });
            if (loadOptions.filter) {
                loadOptions.filter.forEach((item: any) => {
                    params += `${item[0]}=${item[2]}&`
                });

            }
            params = params.slice(0, -1);
            return reportService.getSalesPerformanceReportOne(params)
                .then((response) => ({
                    data: response.data.searchResult,
                    totalCount: response.data.totalCount,
                }))
                .catch((err) => {
                    throw new Error('Data Loading Error');
                });
        },

    });
}
var filter: Array<FilterDescriptor> = [];

export default function SalesPerformanceGridReportReportOne() {

    const [startDate, setStartDate] = useState<Date>(new Date(2024, 0, 1))
    const [endDate, setEndDate] = useState<Date>(new Date())
    const [productGroups, setProductGroups] = useState<any>([]);
    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'info',
        message: '',
    });

    function addToFilterArray(filter: any, key: any, operator: any, value: any) {
        const existingIndex = filter.findIndex((item: any) => item[0] === key);
        if (existingIndex !== -1) {
            filter.splice(existingIndex, 1);
        }
        if (value != undefined)
            filter.push([key, operator, value]);

    }

    function onSubProductValueChanged(e: any) {
        addToFilterArray(filter, 'productGroup', '=', e.value ?? undefined);
        store.filter(filter);
        store.load();
    }

    function onRetailerValueChanged(e: any) {
        addToFilterArray(filter, 'retailerId', '=', e.value ?? undefined);
        store.filter(filter);
        store.load();
    }
    function onStartDateValueChanged(e: any) {

        setStartDate(e.value);
        addToFilterArray(filter, 'startDate', '=', extFormatDate(e.value));
        store.filter(filter);
        store.load();
    }
    function onEndDateValueChanged(e: any) {
        setEndDate(e.value);

        addToFilterArray(filter, 'endDate', '=', extFormatDate(e.value));
        store.filter(filter);
        store.load();
    }

    function getDefaultFilterValues() {

        addToFilterArray(filter, 'startDate', '=', extFormatDate(startDate));
        addToFilterArray(filter, 'endDate', '=', extFormatDate(endDate));
        return filter;
    }
    function formatCurrency(arg: any) {
        return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(arg.value);
    }
    function getProductGroups() {

        return lookupService.getProductGroupLookup({})
            .then((response) => (
                setProductGroups(response.data)
            ))
            .catch(() => { throw new Error('Data Loading Error'); });
    }
    function onExporting(e: any) {

        var diff = Math.abs(startDate.getTime() - endDate.getTime());
        var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        if (diffDays <= 60) {
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Sales_Performance_Analysis_for_Specific_Period.xlsx');
                });
            });
        }
        else {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'info',
                message: 'Excel"e aktarmak için en fazla 60 günlük bir periyod seçebilirsiniz.'
            });
        }
    }

    useState(() => {
        const defaultFilterValues = getDefaultFilterValues();
        getProductGroups();
        getDataSource(defaultFilterValues);

    })

    function onHiding() {
        setToastConfig({
            ...toastConfig,
            isVisible: false,
        })
    }

    const allowedPageSizes = [10, 15, 20, 25, 50, 100, 200];

    return (
        <>
            <Row>
                <h5 className="text-center m-10"> Sales Performance Analysis for Specific Period</h5>
            </Row>
            <br></br>
            <Row>
                <Toast
                    visible={toastConfig.isVisible}
                    message={toastConfig.message}
                    type='info'
                    onHiding={onHiding}
                    displayTime={1000}
                />
                <Col md={1}></Col>
                <Col md={2}>
                    <Form.Label htmlFor="productGroups">Product Group</Form.Label>
                    <SelectBox
                        name='productGroups'
                        showClearButton={true}
                        dataSource={productGroups}
                        // defaultValue={productGroups[0].Value}
                        valueExpr="value"
                        displayExpr="text"
                        onValueChanged={onSubProductValueChanged}
                    />
                </Col>
                <Col md={2}>
                    <Form.Label htmlFor="retailers">Retailers</Form.Label>
                    <SelectBox
                        name='retailers'
                        showClearButton={true}
                        dataSource={reatiler}
                        // defaultValue={reatiler[0].Value}
                        valueExpr="Value"
                        displayExpr="Text"
                        onValueChanged={onRetailerValueChanged}
                    />
                </Col>
                <Col md={3}>
                    <Form.Label htmlFor="startDate">Start Date</Form.Label>
                    <DateBox
                        value={startDate}
                        name='startDate'
                        type="date"
                        onValueChanged={onStartDateValueChanged}
                    />
                </Col>
                <Col md={3}>
                    <Form.Label htmlFor="endDate">End Date</Form.Label>
                    <DateBox
                        value={endDate}
                        name='endDate'
                        type="date"
                        onValueChanged={onEndDateValueChanged}
                    />
                </Col>
                <Col md={1}></Col>
            </Row>
            <br></br>
            <DataGrid
                cacheEnabled={false}
                className={'dx-card wide-card'}
                dataSource={store}
                showBorders={true}
                showColumnLines={false}
                columnAutoWidth={true}
                columnHidingEnabled={false}
                // focusedRowEnabled={true}
                // defaultFocusedRowIndex={0}
                remoteOperations={true}
                onExporting={onExporting}

            >
                <Scrolling columnRenderingMode='virtual' />
                <Export enabled allowExportSelectedData />
                <Column
                    dataField={'supplier'}

                    caption={'Supplier'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'retailer'}

                    caption={'Retailer'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'province'}

                    caption={'Province'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'store'}

                    caption={'Store'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'productGroup'}

                    caption={'Product Group'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'subProductGroup'}

                    caption={'Sub Product Group'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'product'}

                    caption={'Product'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'salesAmount'}
                    customizeText={formatCurrency}
                    caption={'Sales Amount'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'salesQuantity'}
                    caption={'Sales Quantity'}
                    allowFiltering={false}
                />
                <Column
                    dataField={'salesAvgAmount'}
                    customizeText={formatCurrency}
                    caption={'Sales Avg Amount'}
                    allowFiltering={false}
                />

                <Paging defaultPageSize={10} />
                <Pager
                    showNavigationButtons={true}
                    visible={true}
                    showInfo={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes} />
                <FilterRow visible={true} />
            </DataGrid>

        </>
    );
}
